import * as apiFactory from "./ApiFactory";
import { Api } from "./Api";

import type InstanceOfAdvice from "@/models/InstanceOfAdvice";

export async function getAll(clientName: string, brand: string, caseReference: string): Promise<InstanceOfAdvice[]> {
  const client: Api = await apiFactory.FeatuerWithBearer();
  return client.getWithPollingSignal<InstanceOfAdvice[]>(["api/instanceofadvice", clientName, brand, caseReference]);
}

export async function addAll(
  clientName: string,
  brand: string,
  caseReference: string,
  instanceReference = "",
  fileReferences: string[],
): Promise<void> {
  const client: Api = await apiFactory.WithBearer();
  return client.post<string[], void>(
    ["api/instanceofadvice", clientName, brand, caseReference, instanceReference],
    fileReferences,
  );
}

export async function add(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  instanceReference = "",
): Promise<void> {
  const client: Api = await apiFactory.WithBearer();
  return client.post(["api/instanceofadvice", clientName, brand, caseReference, fileReference, instanceReference]);
}

export async function deleteIoa(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  instanceReference: string,
): Promise<void> {
  const client: Api = await apiFactory.WithBearer();
  return client.delete(["api/instanceofadvice", clientName, brand, caseReference, fileReference, instanceReference]);
}
